<form [formGroup]="firstFormGroup">
  @if (setup) {
  <h2>Two-factor Authentication Setup</h2>
  <p>
    Two-factor authentication(2FA) is an extra layer of security that is used when logging into our services
    and needs to be setup before you can use your account.<br />
    <a href="">Learn more</a>
  </p>
  } @else {
  <br />
  <h3>Two-factor authentication</h3>
  <p>
    Two-factor authentication (2FA) is an extra layer of security used when logging into our services.<br />
    <a href="https://diysurveys.zendesk.com/hc/en-us/articles/26979813200530-Two-Factor-Authentication-2FA-on-DIY-Surveys" target="_blank">Learn more</a>
  </p>
  }
  <div>
    <div *ngIf="smsEnabled">

    </div>
  </div>
  <p *ngIf="!emailSetup">
    Use your email account to get two-factor authentication codes when prompted.
  </p>
  <div class="mb-10">
    <strong>{{user.EmailAddress}}</strong>&nbsp;
    <button *ngIf="!hasSent && !emailSetup" mat-raised-button type="button" color="primary" (click)="send2FAEmail($event)">Send Email Verification Code</button>
  </div>
  <div *ngIf="(hasSent && !emailSetup)" class="mb-10">
    <span style="font-size:1em">Confirm Access Code</span>
    <app-tfentry #tfentryemail [(value)]="code" (completed)="confirm2FAEmail()"></app-tfentry>
    <br />
    <button mat-raised-button color="primary" type="button" (click)="confirm2FAEmail()">Confirm Email Verification Code</button>&nbsp;
    <button mat-raised-button color="accent" type="button" (click)="send2FAEmail($event)">Resend Email Verification Code</button>
  </div>
  <div class="mb-10" *ngIf="emailSetup">
    Email two-factor enabled.&nbsp;
    <button mat-stroked-button color="primary" type="button" (click)="disableEmail2FA()">Disable Email 2FA</button>&nbsp;
  </div>
  <mat-divider></mat-divider>
  <p>
    <br />
    For additional security DIY Surveys can send you an SMS with a two-factor authentication code when prompted. SMS cannot be delivered in all countries.
    Check that <a href="https://diysurveys.zendesk.com/hc/en-us/articles/26979886672658-List-of-Supported-Countries-for-SMS-2FA" target="_blank">your country is supported</a> before you select this option.
  </p>
  <div>
    <mat-form-field appearance="outline" class="widthThirty">
      <mat-label>Mobile Number</mat-label>
      <input matInput type="text" [readonly]="smsSetup" placeholder="Mobile Number" formControlName="MobileNumber" />
    </mat-form-field>&nbsp;
    <div class="mb-10" *ngIf="smsSetup">
      SMS two-factor enaabled.&nbsp;
      <button mat-stroked-button color="primary" type="button" (click)="disableSms2FA()">Disable SMS 2FA</button>&nbsp;
    </div>
    <button *ngIf="!smsSetup && !hasSmsSent" mat-raised-button type="button" color="primary" (click)="send2FASms()">Send SMS Verification Code</button>&nbsp;
    <div *ngIf="hasSmsSent && !smsSetup">
      <span style="font-size:1em">Confirm SMS Access Code</span>
      <app-tfentry #tfentrysms [(value)]="code" (completed)="confirm2FASms()"></app-tfentry>
      <br />
      <button mat-raised-button color="primary" type="button" (click)="confirm2FASms()">Confirm SMS Verification Code</button>&nbsp;
      <button mat-raised-button color="accent" type="button" (click)="send2FASms()">Resend SMS Verification Code</button>&nbsp;
    </div>
  </div>
  <div *ngIf="!setup && devices.length > 0">
    <mat-divider></mat-divider>
    <div class="mt-15">
      <h3>Recent Login History</h3>
    </div>
    <div class="fieldRowWithPadding" *ngFor="let device of devices; let i = index">
      IPAddress: {{device.IPAddress}}, Country: {{device.Country}}, Last Logged In: {{device.LastUsed  | date:'medium'}}, Device: {{device.DeviceType}}
    </div>
  </div>
</form>
